export default {"src":"/_next/static/media/insuranceLogo5.fd643e9c.svg","height":54,"width":175,"blurWidth":0,"blurHeight":0};